export default {
	TransferInvList: [],
	Total: 0,
	IsLoadingTotalRecords: false
};
